var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import Form from "@irati/ui/src/Form";
import { injectIntl } from "@irati/utils/lang";
import { CompanyNewsTileType } from "@irati/types";
import { updateCompanyNewsTile } from "@irati/homepage/services/homepage";
import tracking from "@irati-tracking/homepage";
import ContentFooter from "./Footer";
import NewImage from "./NewImage";
import NewTemplateTile from "./NewTemplateTile";
import NewVideo from "./NewVideo";
import Preview from "./Preview";
import { ModalContent } from "../../Modal/styled";
import { SelectedTab } from "./types";
var CompanyNewsContentForm = /** @class */ (function (_super) {
    __extends(CompanyNewsContentForm, _super);
    function CompanyNewsContentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            updatedContent: _this.props.companyNewsTile.config
        };
        _this.updateTile = function (tileConfig, tile, onClose) {
            var _a = _this.props, currentTab = _a.currentTab, auth = _a.auth;
            var variables = {
                tenantId: auth.business.uuid,
                tile: {
                    config: tileConfig,
                    xpos: tile.xpos,
                    ypos: tile.ypos
                }
            };
            _this.setState({ load: true });
            updateCompanyNewsTile(variables).then(function () {
                _this.setState({ load: false });
                tracking.homePageAddNewTileSubmit(currentTab);
                onClose();
            });
        };
        _this.validateHasImage = function (newContentObject) {
            if (newContentObject.type === CompanyNewsTileType.Video) {
                return true;
            }
            if (newContentObject.type === CompanyNewsTileType.Template) {
                return true;
            }
            if (!newContentObject.imageUrl) {
                _this.setState({ imageError: _this.props.formatMessage({ id: "platform.homepage.companyNews.editContent.imageRequired" }) });
                return false;
            }
            return true;
        };
        _this.getType = function () {
            var _a = _this.props, currentTab = _a.currentTab, companyNewsTile = _a.companyNewsTile;
            if (currentTab === SelectedTab.EDIT) {
                return companyNewsTile.config.type;
            }
            if (currentTab === SelectedTab.VIDEO) {
                return CompanyNewsTileType.Video;
            }
            if (currentTab === SelectedTab.TEMPLATE) {
                return CompanyNewsTileType.Template;
            }
            return CompanyNewsTileType.Image;
        };
        _this.updateStateContent = function (c) { return _this.setState({ updatedContent: c }); };
        _this.showPreview = function (showPreview) { return _this.props.setPreview(showPreview); };
        return _this;
    }
    CompanyNewsContentForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, companyNewsTile = _a.companyNewsTile, isPreview = _a.isPreview, onClose = _a.onClose;
        var _b = this.state, imageError = _b.imageError, updatedContent = _b.updatedContent;
        var newContentObject = Object.assign({}, updatedContent, {
            type: this.getType()
        });
        return (React.createElement(Form, { onSubmit: function () {
                var isValid = _this.validateHasImage(newContentObject);
                if (isValid) {
                    _this.updateTile(newContentObject, companyNewsTile, onClose);
                }
            } },
            React.createElement(ModalContent, null,
                isPreview && React.createElement(Preview, { companyNewsTileConfig: newContentObject }),
                !isPreview && newContentObject.type === CompanyNewsTileType.Image && (React.createElement(NewImage, { companyNewsTileConfig: newContentObject, imageError: imageError, removeImageError: function () { return _this.setState({ imageError: undefined }); }, updateContent: this.updateStateContent })),
                !isPreview && newContentObject.type === CompanyNewsTileType.Video && (React.createElement(NewVideo, { companyNewsTileConfig: newContentObject, updateContent: this.updateStateContent })),
                !isPreview && newContentObject.type === CompanyNewsTileType.Template && (React.createElement(NewTemplateTile, { companyNewsTileConfig: newContentObject, updateContent: this.updateStateContent }))),
            React.createElement(ContentFooter, { isPreviewView: isPreview, showPreview: this.showPreview, onSubmit: function () {
                    var isValid = _this.validateHasImage(newContentObject);
                    if (isValid) {
                        _this.updateTile(newContentObject, companyNewsTile, onClose);
                    }
                } })));
    };
    return CompanyNewsContentForm;
}(Component));
export default injectIntl(withAuth(CompanyNewsContentForm));
